import React, { useContext, useEffect, useState } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { Container } from 'reactstrap';

import {
  AppAside,
  AppBreadcrumb,
  AppFooter,
  AppHeader,
  AppSidebar,
  AppSidebarFooter,
  AppSidebarForm,
  AppSidebarHeader,
  AppSidebarMinimizer,
  AppSidebarNav,
} from '@coreui/react';
// sidebar nav config
import navigation from '../../_nav';
// routes config
import routes from '../../routes';

import DefaultAside from './DefaultAside';
import DefaultFooter from './DefaultFooter';
import DefaultHeader from './DefaultHeader';
import Context from '../../store/Context';

function DefaultLayout(props) {
  const { menu, isShowEditor, setIsShowEditor } = useContext(Context)

  useEffect(() => {
    const menuLink = document.querySelector('.nav-link.active');
    menuLink.addEventListener('click', function (event) {
      setIsShowEditor(false)
    });
  })


  return (
    <div className="app">

      <AppHeader fixed>
        <DefaultHeader />
      </AppHeader>
      <div className="app-body">
        {menu && <AppSidebar fixed display="lg">
          <AppSidebarHeader />
          <AppSidebarForm />
          <AppSidebarNav navConfig={menu} {...props} />
          <AppSidebarFooter />
          <AppSidebarMinimizer />
        </AppSidebar>}
        <main className="main">
          <AppBreadcrumb appRoutes={routes} />
          <Container fluid>
            <Switch>
              {routes.map((route, idx) => {
                return route.component ? (<Route key={idx} path={route.path} exact={route.exact} name={route.name} render={props => (
                  <route.component {...props} />
                )} />)
                  : (null);
              },
              )}
              <Redirect from="/" to="/dashboard" exact />
            </Switch>
          </Container>
        </main>
        <AppAside fixed hidden>
          <DefaultAside />
        </AppAside>
      </div>
      <AppFooter>
        <DefaultFooter />
      </AppFooter>

    </div>
  );
}

export default DefaultLayout;



// WEBPACK FOOTER //
// ./src/containers/DefaultLayout/DefaultLayout.js